import { css } from "@emotion/css";
import { fontWeight, themeTokens } from "@octopusdeploy/design-system-tokens";
import { type ReactNode } from "react";
interface ConfigWizardHelpLayoutProps {
    title: string;
    children?: ReactNode;
}
export function ConfigWizardHelpLayout({ title, children }: ConfigWizardHelpLayoutProps) {
    const styles = {
        content: css({
            marginTop: 0,
            h3: {
                marginTop: 0,
                fontWeight: fontWeight["700"],
                color: themeTokens.color.dialog.helpPanel.text,
            },
            p: {
                color: themeTokens.color.dialog.helpPanel.text,
            },
        }),
    };
    return (<div className={styles.content}>
            <h3>{title}</h3>
            <p>{children}</p>
        </div>);
}
